import { useEffect, useState } from 'react';

import { firestore } from '../firebase';
import { FirestoreCollection } from '../firebase.models';

export const useGetMObywatelRejectionMessage = (userUid: string | null): string | null => {
  const [rejectionMessage, setRejectionMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!userUid) {
      setRejectionMessage(null);
      return;
    }

    const unsubscribe = firestore
      .collection(FirestoreCollection.MOBYWATEL_REQUESTS)
      .where('userUid', '==', userUid)
      .where('status', '==', 'rejected')
      .orderBy('createdAt', 'desc')
      .limit(1)
      .onSnapshot((snapshot) => {
        if (!snapshot.empty) {
          const latestRejectedRequest = snapshot.docs[0].data();
          const rejectionReason = latestRejectedRequest.rejectionReason;
          const customMessage = latestRejectedRequest.customRejectionMessage;

          if (rejectionReason === 'custom' && customMessage) {
            setRejectionMessage(customMessage);
          } else if (rejectionReason === 'incorrect_data') {
            setRejectionMessage('Imię lub nazwisko niepoprawne. Popraw dane w zakładce "Informacje o koncie".');
          } else if (rejectionReason === 'time_expired_error') {
            setRejectionMessage('Błąd sieci. Nie udało się zweryfikować danych. Spróbuj ponownie.');
          } else {
            setRejectionMessage(null);
          }
        } else {
          setRejectionMessage(null);
        }
      });

    return () => unsubscribe();
  }, [userUid]);

  return rejectionMessage;
};
